'use client';
import React from 'react';
import { Switch, Space, Col } from 'antd';
import { ButtonCommon } from '../Button/ButtonCommon';
import { GlobeHemisphereEast } from '@phosphor-icons/react';

import ToolbarLayout from './ToolbarLayout';

export interface ToolbarCommonProps {
  isActive: boolean;
  isEdit?: boolean;
  isCopy?: boolean;
  barcode?: string;
  nameProduct?: string;
  isLoading: boolean;
  onCancel?: () => void;
  onPublish: () => void;
  onActive?: (isActive: boolean) => void;
  entityName?: string;
  displaySwitch?: boolean; // Optional prop to control switch display
}

const ToolbarCommon: React.FC<ToolbarCommonProps> = ({
  isActive,
  isEdit,
  isCopy = false,
  barcode,
  nameProduct = '',
  isLoading,
  onCancel,
  onPublish,
  onActive,
  entityName = 'sản phẩm',
  displaySwitch = true, // Default to true if not provided
}) => {
  return (
    <ToolbarLayout
      left={
        <Space align='center' className='!gap-6 flex-wrap'>
          {barcode && (
            <Space size='small' align='center' className='text-[14px] leading-[20px]'>
              <p className='text-[var(--textBlack56)]'>Mã {entityName}:</p>
              <span className='font-medium'>{barcode}</span>
            </Space>
          )}
          <Space size='small' align='center' className='text-[14px] leading-[20px]'>
            <p className='text-[var(--textBlack56)]'>Tên {entityName}:</p>
            <span className='font-medium'>{nameProduct}</span>
          </Space>
          {displaySwitch && (
            <Space size='small' align='center' className='text-[14px] leading-[20px]'>
              <Switch
                checked={isActive}
                disabled={(!isEdit && !isCopy) || isLoading}
                onChange={onActive}
                className={`h-6 ${isEdit || isCopy ? 'cursor-not-allowed' : ''}`}
              />
              <p>Kích hoạt {entityName}</p>
            </Space>
          )}
        </Space>
      }
      right={
        <Col>
          <Space size='middle' align='center'>
            {onCancel && (
              <ButtonCommon
                color='none'
                fullWidth
                radius='rounded'
                size='md'
                className='bg-white px-0 text-black'
                onClick={onCancel}
              >
                Hủy
              </ButtonCommon>
            )}
            <ButtonCommon
              color='primary'
              fullWidth
              radius='rounded'
              size='md'
              className='bg-[var(--primaryColor500)] px-3 gap-2'
              onClick={onPublish}
            >
              <div className='w-5 h-5'>
                <GlobeHemisphereEast color='#fff' size={20} />
              </div>
              <span className='whitespace-nowrap text-white'>
                {isLoading ? 'Đang lưu thông tin...' : `Lưu thông tin`}
              </span>
            </ButtonCommon>
          </Space>
        </Col>
      }
    />
  );
};

export default ToolbarCommon;
